import 'css-chunksrc/client/scenes/projectCreationForm/styles.scss';export default {
  "projectCreationForm": "_projectCreationForm_4phmy_1",
  "column": "_column_4phmy_8",
  "withZone": "_withZone_4phmy_13",
  "section": "_section_4phmy_20",
  "formGroup": "_formGroup_4phmy_32",
  "title": "_title_4phmy_36",
  "nameInput": "_nameInput_4phmy_45",
  "description": "_description_4phmy_55",
  "descriptionInput": "_descriptionInput_4phmy_59",
  "dateGroup": "_dateGroup_4phmy_64",
  "tagsGroup": "_tagsGroup_4phmy_72",
  "row": "_row_4phmy_82",
  "col": "_col_4phmy_8",
  "projectPortfoliosList": "_projectPortfoliosList_4phmy_109",
  "tags": "_tags_4phmy_72",
  "dateTimeInput": "_dateTimeInput_4phmy_117",
  "avatar": "_avatar_4phmy_121",
  "zoneTitle": "_zoneTitle_4phmy_134",
  "inZoneSpace": "_inZoneSpace_4phmy_142",
  "maxCharacters": "_maxCharacters_4phmy_146",
  "errorTitleInput": "_errorTitleInput_4phmy_152",
  "titleError": "_titleError_4phmy_156",
  "heading": "_heading_4phmy_162",
  "subTitle": "_subTitle_4phmy_171",
  "configurationIcon": "_configurationIcon_4phmy_177",
  "secondaryCriteria": "_secondaryCriteria_4phmy_187",
  "dates": "_dates_4phmy_194",
  "date": "_date_4phmy_64",
  "status": "_status_4phmy_207",
  "criteriatags": "_criteriatags_4phmy_214",
  "icon": "_icon_4phmy_221",
  "name": "_name_4phmy_45",
  "weather": "_weather_4phmy_242",
  "weatherIcon": "_weatherIcon_4phmy_248",
  "container": "_container_4phmy_261",
  "activityMonitoring": "_activityMonitoring_4phmy_268",
  "workload": "_workload_4phmy_269",
  "budget": "_budget_4phmy_270",
  "text": "_text_4phmy_289",
  "positive": "_positive_4phmy_293",
  "warning": "_warning_4phmy_297",
  "contextualMenu": "_contextualMenu_4phmy_301",
  "opened": "_opened_4phmy_301",
  "zone": "_zone_4phmy_134"
};